// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts"
// @generated from file households.proto (package nail2poll, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Household, HouseholdPaginationResp, HouseholdsList, HouseholdsServiceCountRequest, HouseholdsServiceCreateRequest, HouseholdsServiceFilterReq, HouseholdsServicePaginationReq, HouseholdsServiceSearchAllReq, HouseholdsServiceUpdateRequest } from "./households_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { ActiveRequest, CountResponse, CSVImport, ErroredResponse, Identifier, IdentifierWithUserComment, StandardFile } from "./base_pb.js";

/**
 *
 * Describes the methods applicable on each household
 *
 * @generated from service nail2poll.HouseholdsService
 */
export const HouseholdsService = {
  typeName: "nail2poll.HouseholdsService",
  methods: {
    /**
     * Create a household
     *
     * @generated from rpc nail2poll.HouseholdsService.Create
     */
    create: {
      name: "Create",
      I: HouseholdsServiceCreateRequest,
      O: Household,
      kind: MethodKind.Unary,
    },
    /**
     * Update a household
     *
     * @generated from rpc nail2poll.HouseholdsService.Update
     */
    update: {
      name: "Update",
      I: HouseholdsServiceUpdateRequest,
      O: Household,
      kind: MethodKind.Unary,
    },
    /**
     * Archive the household
     *
     * @generated from rpc nail2poll.HouseholdsService.Archive
     */
    archive: {
      name: "Archive",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * Restore the household
     *
     * @generated from rpc nail2poll.HouseholdsService.Restore
     */
    restore: {
      name: "Restore",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * View by UUID
     *
     * @generated from rpc nail2poll.HouseholdsService.ViewByUUID
     */
    viewByUUID: {
      name: "ViewByUUID",
      I: Identifier,
      O: Household,
      kind: MethodKind.Unary,
    },
    /**
     * View all households
     *
     * @generated from rpc nail2poll.HouseholdsService.ViewAll
     */
    viewAll: {
      name: "ViewAll",
      I: ActiveRequest,
      O: HouseholdsList,
      kind: MethodKind.Unary,
    },
    /**
     * View households with pagination
     *
     * @generated from rpc nail2poll.HouseholdsService.ViewWithPagination
     */
    viewWithPagination: {
      name: "ViewWithPagination",
      I: HouseholdsServicePaginationReq,
      O: HouseholdPaginationResp,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given search key
     *
     * @generated from rpc nail2poll.HouseholdsService.SearchAll
     */
    searchAll: {
      name: "SearchAll",
      I: HouseholdsServiceSearchAllReq,
      O: HouseholdsList,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given filter criteria
     *
     * @generated from rpc nail2poll.HouseholdsService.Filter
     */
    filter: {
      name: "Filter",
      I: HouseholdsServiceFilterReq,
      O: HouseholdsList,
      kind: MethodKind.Unary,
    },
    /**
     * Count
     *
     * @generated from rpc nail2poll.HouseholdsService.Count
     */
    count: {
      name: "Count",
      I: HouseholdsServiceCountRequest,
      O: CountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ------------------------------------------------------
     * Import and Export operations are listed below
     * Import from CSV file
     *
     * @generated from rpc nail2poll.HouseholdsService.Import
     */
    import: {
      name: "Import",
      I: CSVImport,
      O: ErroredResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Export to CSV file
     *
     * @generated from rpc nail2poll.HouseholdsService.Export
     */
    export: {
      name: "Export",
      I: HouseholdsServiceFilterReq,
      O: StandardFile,
      kind: MethodKind.Unary,
    },
  }
} as const;

